import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgFrameworkComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { EQueryStatus } from '../../../e-queries/models/e-query-status';
import { AgeInfo } from '../../../e-queries/age-info';

@Component({
    selector: 'age-cell',
    template: require('./age-renderer.component.html'),
    styles: [require('./age-renderer.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgeRendererComponent implements AgFrameworkComponent<ICellRendererParams> {
    public value: string;
    public isExpired = false;
    public agInit(params: { data: AgeInfo }): void {
        const ageInfo = params.data;
        if (ageInfo) {
            const distance = ageInfo.eQueryAge;
            this.value = distance.formattedValue;
            this.isExpired = distance.days > 0 && ageInfo.eQueryStatus !== EQueryStatus.Closed;
        }
    }
}
